import { FormEvent, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './Account.module.css';

import { useAppSelector } from '../../../hooks/useRedux';
import { useValidatePwdMutation } from '../../../services/settings';

import { Link, useNavigate } from 'react-router-dom';

import {
  COMPLETE,
  ENTER,
  ENTER_PASSWORD_MESSAGE,
  FIND,
  ENTER_PASSWORD_FOR_CHANGE,
  PASSWORD,
  ACCOUNT_INFO,
} from '../../../constants';
import { selectUser } from '../../../features/authSlice';
import { setLocalStorage } from '../../../utils/storage';

export default function Account() {
  const cx = classNames.bind(styles);
  const user = useAppSelector(selectUser);
  const [validatePwd] = useValidatePwdMutation();
  const navigate = useNavigate();
  const [pwd, setPwd] = useState('');
  const [isEnableBtn, setIsEnableBtn] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [msg, setMsg] = useState('');

  const onChangePwd = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setIsEnableBtn(!!value.length);
    setPwd(value);
  };

  const validatePassword = async (e: FormEvent) => {
    e.preventDefault();
    try {
      const pwdRes: any = await validatePwd(pwd).unwrap();
      setMsg(pwdRes.message);
      setIsValid(pwdRes.message === 'OK');
      pwdRes.message === 'OK' && navigate('../profile');
    } catch (error) {
      console.log('Failed to Validate Password', error);
    }
  };

  if (!user) return null;

  return (
    <form onSubmit={validatePassword}>
      <h2>{ACCOUNT_INFO}</h2>
      <div className={cx('st_signup')}>
        <p className={cx('fs18', 'tac')}>{user.email}</p>
        <p className={cx('desc', 'tac')}>{ENTER_PASSWORD_FOR_CHANGE}</p>

        <div className={cx('input_area')}>
          <div
            className={cx(
              'input_box',
              { 'input--done': isValid },
              { 'input--error': !isValid }
            )}
          >
            <span className={cx('blind')}>
              {PASSWORD} {ENTER}
            </span>
            <input
              type="password"
              id="password"
              title={`${PASSWORD} ${ENTER}`}
              placeholder={ENTER_PASSWORD_MESSAGE}
              autoCapitalize="current-password"
              onChange={onChangePwd}
            />
            <span className={cx('msg', { invalid: !isValid })}>
              {!isValid && msg}
            </span>
          </div>
        </div>

        <div className={cx('row')}>
          <Link
            to="/login/forgot-password"
            className={cx('abtn', 'find_password')}
            state={{ menu: 'settings' }}
          >
            <span>
              {PASSWORD} {FIND}
            </span>
          </Link>
        </div>

        <div className={cx('btn_wrap', 'bottom')}>
          <button
            type="submit"
            className={cx('btn', 'b_t', 's48', {
              'is--disabled': !isEnableBtn,
            })}
            disabled={!isEnableBtn}
          >
            <span>{COMPLETE}</span>
          </button>
        </div>
      </div>
    </form>
  );
}
